export default __webpack_public_path__ + "static/media/gallery_00.13a58611.jpg";